export default {
  gradeMap: {
    0: '학년 전체',
    1: '초 1',
    2: '초 2',
    3: '초 3',
    4: '초 4',
    5: '초 5',
    6: '초 6',
    7: '중 1',
    8: '중 2',
    9: '중 3',
    10: '고 1',
    11: '고 2',
    12: '고 3',
    9999: '선택',
    null: '기타',
  },
};



// WEBPACK FOOTER //
// ./src/app/cat-proficiency/store/state.js